import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/mobile-overrides.css'
import App from './App.tsx'

let DebugPanel: any = null;
if (import.meta.env.DEV) {
  try {
    // dynamic import so production build tree-shakes it away
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    DebugPanel = require('./components/DebugPanel/DebugPanel').default;
  } catch (e) {
    DebugPanel = null;
  }
}

createRoot(document.getElementById('root')!).render(
  <>
    <App />
    {DebugPanel ? <DebugPanel /> : null}
  </>
)

// In development, unregister any service workers to avoid aggressive caching during iterative work
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  // Try to unregister all service workers registered for this origin
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => {
      try { r.unregister(); } catch (e) { /* ignore */ }
    });
  }).catch(() => {/* ignore */});

  // Also attempt to unregister common filenames
  try {
    navigator.serviceWorker.getRegistration('/sw.js').then((reg) => { if (reg) reg.unregister(); }).catch(() => {});
  } catch (e) { /* ignore */ }
}
